$(document).ready(function() {
  var mainMenu = $("header.header"),
    btnMenu = $(".btn.header__menu-btn");
  btnMenu.click(function() {
    mainMenu.toggleClass("header--open");
  });

  // nav sub items
  $(".header__nav .plus-btn").click(function() {
    $(this).parent().find(".nav__sub-items").slideToggle("fast");
    $(this).toggleClass("active");
  });

  // Close menu with esc key
  $(document).keyup(function(e) {
    if (e.keyCode == 27) {
      if (mainMenu.hasClass("header--open")) {
        mainMenu.toggleClass("header--open");
      }
    }
  });
});
